<template>
  <div>
    <div @click="toggleChatBox()" class="chat-toggle__container" :class="classes">
      <aha-icon
        name="chat-canvas"
        class="chat-toggle__icon"
        v-if="!hasChatNotification"
      />
      <aha-icon
        name="chat-canvas-noti"
        class="chat-toggle__icon has-noti"
        v-else
      />
      <span>Chat</span>
    </div>
    <div class="chat-box__tip" :class="{'dark': isDarkTheme}" v-if="chatBoxVisible" />
    <slot v-if="chatBoxVisible" />
  </div>
</template>
<script>
export default {
  name: 'ChatToggle',
  props: {
    classes: {
      type: String,
      default: '',
    },
    chatBoxVisible: {
      type: Boolean,
      default: false,
    },
    hasChatNotification: {
      type: Boolean,
      default: false,
    },
    isDarkTheme: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleChatBox() {
      this.$emit('toggleChatBox')
    },
  },
}
</script>
<style lang="scss" scoped>
.chat-toggle__container {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  .chat-toggle__icon {
    width: 30px;
    padding-left: 1px;
    margin-bottom: 1px;
    &.has-noti {
      padding-left: 0;
    }
  }
}
.chat-box__tip {
  position: absolute;
  width: 13px;
  z-index: 1;
  height: 13px;
  top: -29px;
  left: 2.75rem;
  background:#ffffff;
  transform: translate(-50%, 0) rotate(45deg);
  border-bottom-right-radius: 2px;
  outline: none;
  &.dark {
    background: #000000;
    box-shadow: 2px 2px 3px rgba(255, 255, 255, 0.04);
  }
}
</style>
